
export class Usernames {
  static getPossibleUsernames(username, keyword) {
    var usernames = [];
    
    if(!keyword) {
      keyword = username;
      username = undefined;
    }
    
    if(username) {
      var usernames = [username];
    }
    
    var keyUser = keyword.trim().replace(/\s+/g, " ").replace(" ", "-");
    usernames.push(keyUser);
    
    var noDashUser = keyUser.replace("-", "");
    usernames.push(noDashUser);
    
    usernames.push(noDashUser + "1");
    usernames.push(noDashUser + "2");
    
    // no duplicates
    return usernames.filter(function onlyUnique(value, index, self) { 
      return self.indexOf(value) === index;
    });
  }
  
  static async showBasicAuthUsers(usersPromise, item) {
    return (await Promise.all(item.authBasicUsers.map((authBasicUser) => this.getUserFullName(usersPromise, authBasicUser)))).join(", ");
  }
  
  static async getUserFullName(usersPromise, username) {
    // may be the many<->many record
    if(username.authUsername) {
      username = username.authUsername;
    }
    
    if(!username) {
      return username;
    }
    
    const users = await usersPromise;
    
    for(const user of users) {
      if(user.username == username) {
        return user.firstName + " " + user.lastName;
      }
    }
    
    return username;
  }
}



// WEBPACK FOOTER //
// ./src/util/usernames.js